import { render, staticRenderFns } from "./TodoHeader.vue?vue&type=template&id=5ff94408&"
import script from "./TodoHeader.vue?vue&type=script&lang=js&"
export * from "./TodoHeader.vue?vue&type=script&lang=js&"
import style0 from "./TodoHeader.vue?vue&type=style&index=0&id=5ff94408&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports